import React from 'react';
import CityPage from '../CityPage/CityPage';
import image from './PetrieIsland.jpg';

const PetrieIslandPage = () => (
  <CityPage
    city="Petrie Island"
    region="Ontario"
    country="Canada"
    countryCode="CA"
    routePath="/petrieisland"
    currentPage="PetrieIslandPage"
    image={image}
    imageAlt="Boat rentals at Petrie Island on the Ottawa River in Orléans"
    intro="Petrie Island is a city park on the Ottawa River in Orléans — one of the easiest launches in the National Capital Region for swimming, paddling and powerboating. WetRentals hosts in the east end can deliver Sea-Doos, pontoons, kayaks and more right to the launch."
    sections={[
      {
        heading: 'Where to boat at Petrie Island',
        body:
          'The Petrie Island boat launch opens directly to the Ottawa River with easy runs west toward downtown Ottawa or east toward Cumberland and the Quebec shore. Beaches and calmer back-channels are great for paddling and family days.',
      },
      {
        heading: 'What you can rent at Petrie Island',
        body:
          'Sea-Doo and Jet Ski rentals for the open river, pontoon boats for family cruising, fishing boats, plus kayaks, canoes and paddleboards for the back-channels.',
      },
      {
        heading: 'Why book with WetRentals',
        body:
          "WetRentals is Canada's largest peer-to-peer boat rental platform. Every booking includes safety equipment, instant confirmation, host messaging and a flexible cancellation policy.",
      },
    ]}
    searchUrl="/s?address=Petrie%20Island%2C%20Orleans%2C%20Ontario%2C%20Canada&bounds=45.65%2C-75.20%2C45.30%2C-75.90&mapSearch=true"
    searchLabel="Browse all boat rentals near Petrie Island"
  />
);

export default PetrieIslandPage;
